import React from 'react';
import SeoToolPage from './SeoToolPage';

export default function InstagramShadowbanChecker() {
  return (
    <SeoToolPage
      canonicalPath="/instagram-shadowban-checker"
      title="Instagram Shadowban Checker (Free) | Merra AI"
      description="Free Instagram shadowban checker. Enter your handle to see if you're shadowbanned—and what to do when Reels views feel stuck."
      keywords="instagram shadowban checker, am i shadowbanned instagram, how to know if shadowbanned instagram"
      h1="Instagram shadowban checker"
      subheading="Enter your Instagram handle. We'll tell you whether you're shadowbanned—and what actually fixes low Reel views."
      platformLabel="Instagram"
      handlePlaceholder="@yourinstagram"
      inputLabel="Instagram handle"
      ctaLabel="Check shadowban"
      analyzingLabel="Checking…"
      resultTitle="You're not shadowbanned."
      resultParagraphs={[
        'If your Reels get more than 0 views, you are not shadowbanned. Instagram is still showing your content—your content just isn\'t holding attention well enough to get pushed further.',
        'Shadowbans are over-diagnosed. Stuck views usually mean weak hooks, slow openings, or not enough daily tests to discover what works for your niche.',
        'The Merra way: post about 5 trial Reels a day, obsess over retention, and iterate until a format wins. Film your day, then use Merra AI to generate hooks, voiceover, captions, music, and edits so volume is actually doable.',
      ]}
      resultBullets={[
        'You have views → you\'re not banned',
        'Make better content: sharper hooks + faster pacing',
        'Post more: ~5 Reels per day in testing mode',
        'Learn what works: retention first, aesthetics second',
        'Use Merra AI to ship more trials without more editing hours',
      ]}
      sections={[
        {
          title: 'Instagram "shadowban" vs weak content',
          body: 'If friends can find you, hashtags still show some reach, and Reels have any views, you\'re in the normal distribution loop. Instagram tests every Reel. Fail the retention test and reach stays small—even with a healthy account.',
        },
        {
          title: 'What to do instead of worrying about bans',
          body: 'Rewrite the first 2 seconds, cut dead air, and post more. Merra AI helps you turn raw clips into multiple Reel variants so you can run the 5-a-day testing cadence without burning out in CapCut.',
        },
      ]}
      faqs={[
        {
          q: 'Am I shadowbanned on Instagram?',
          a: 'If your content gets more than 0 views, no. Low views almost always mean the Reel didn\'t earn retention—not a silent ban.',
        },
        {
          q: 'Why do my Reels get so few views?',
          a: 'Weak hooks, slow pacing, or unclear payoff in the first seconds. Fix retention and keep posting daily trials.',
        },
        {
          q: 'How often should I post Reels?',
          a: 'About 5 Reels a day while you\'re learning what works, then keep a sustainable cadence once you have winners.',
        },
      ]}
      relatedLinks={[
        { to: '/tiktok-shadowban-checker', label: 'TikTok shadowban checker' },
        { to: '/when-to-post-instagram', label: 'When to post on Instagram' },
        { to: '/ai-video-maker', label: 'AI video maker' },
      ]}
      relatedBlogLinks={[
        { to: '/blog/how-to-know-if-shadowbanned-instagram', label: 'How to know if you\'re shadowbanned on Instagram' },
        { to: '/blog/how-often-to-post-reels', label: 'How often to post Reels' },
        { to: '/blog/hooks-that-increase-retention', label: 'Hooks that increase retention' },
      ]}
    />
  );
}
